import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcTelemetryKey, RpcTelemetryRecord } from './rpc-telemetry-model';

export class RpcTelemetryClient {
    /**
     * The telemetry command.
     *
     * @param data the RpcLogRecord object.
     * @return Promise<void> the promise object.
     */
    public static telemetry(rpc: Rpc, data: RpcTelemetryRecord): Promise<void> {
        return RpcInboundClient.call(rpc, RpcTelemetryKey.command, RpcTelemetryKey.version, data);
    }
}
